<template>
    <span>
        <span v-if="roleItem.role === 'uel'"
              class="pl-5 subtitle-2 primary--text mt-3 mb-1">Trainer-Ausweise:</span>
        <v-row v-if="$store.state.user.permissions[roleItem.permissions] ||
                     $store.state.user.permissions.pass" no-gutters align="center"
                class="px-3">
            <v-col class="text-center py-1" cols="2" sm="1" >
                <v-icon :color="getStatus().color">{{getStatus().icon}}</v-icon>
            </v-col>
            <v-col class="pl-3 py-1" cols="13" sm="2">
                <info-line v-if="!roleItem.isEdited && roleItem.nr" :header="roleItem.label"
                           css="subtitle-1 mb-05" header-font="caption mb-05">
                    {{ roleItem.nr }}
                </info-line>
                <info-line v-else-if="!roleItem.isEdited && !roleItem.nr" header="Pass"
                           css="subtitle-1 mb-05" header-font="caption mb-05">
                    {{ roleItem.emptylabel }}
                </info-line>
                <v-text-field v-else v-model="roleItem.nr" :disabled="!roleItem.isEdited"
                              clearable hide-details :label="roleItem.label"/>
            </v-col>
            <v-col class="pl-3 py-1" cols="12" sm="3"
                   :style="$vuetify.breakpoint.smAndUp?'maxWidth: 174px':''">
                <info-line v-if="!roleItem.isEdited && roleItem.von" header="erstellt am"
                           css="subtitle-1 mb-05" header-font="caption mb-05">
                    {{ roleItem.von }}
                </info-line>
                <v-text-field v-else v-model="roleItem.von" :disabled="!roleItem.isEdited"
                              clearable hide-details label="erstellt am" type="date"/>
            </v-col>
            <v-col class="pl-3 py-1" cols="12" sm="3"
                   :style="$vuetify.breakpoint.smAndUp?'maxWidth: 174px':''">
                <info-line v-if="!roleItem.isEdited && roleItem.bis" header="gültig bis"
                           css="subtitle-1 mb-05" header-font="caption mb-05">
                    {{ roleItem.bis }}
                </info-line>
                <v-text-field v-else v-model="roleItem.bis" :disabled="!roleItem.isEdited"
                              clearable hide-details label="gültig bis" type="date"/>
            </v-col>
            <v-col cols="6" sm="1"
                   :class="[{'lastMinWidth': $vuetify.breakpoint.mdAndUp},
                            {'lastMinWidthSm': $vuetify.breakpoint.smOnly}, 'pl-3 py-1']">
                <info-line v-if="roleItem.tsLastPassPrint" header="zuletzt gedruckt"
                           css="subtitle-1 mb-05" header-font="caption mb-05">
                    {{ roleItem.tsLastPassPrint }}
                </info-line>
            </v-col>
            <v-col v-if="user.permissions.pass" :class="[{'text-right': $vuetify.breakpoint.smAndDown},
                            {'text-center': $vuetify.breakpoint.mdAndUp},
                            'py-1 text-no-wrap']"
                   cols="6" sm="2">
                <v-btn icon @click="editItem()"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn icon @click="clearItem()"
                       :disabled="!getStatus().status.isSaved">
                    <v-icon>mdi-delete</v-icon></v-btn>
                <v-btn icon @click="undoItem()"
                       :disabled="!roleItem.isEdited && !getStatus().status.isChanged">
                    <v-icon>mdi-undo</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-divider v-if="$vuetify.breakpoint.xsOnly" class="mt-5"/>
    </span>
</template>

<script>
import InfoLine from "@/components/elements/infoLine";
export default {
    name: "spieler-rollen-form",
    components: {InfoLine},
    computed: {
        user(){ return this.$store.state.user },
    },
    props: ['roleItem', 'spielerRollen'],
    methods: {
        getStatus(){
            return this.spielerRollen.getStatus(this.roleItem)
        },
        editItem(){
            this.roleItem.isEdited=true
        },
        clearItem(){
            this.spielerRollen.clearItem(this.roleItem)
        },
        undoItem(){
            this.spielerRollen.undoItem(this.roleItem)
        }
    },
}
</script>

<style scoped>
    .lastMinWidth{min-width: 134px}
    .lastMinWidthSm{min-width: 94px}
</style>